<div>
  <div
    *ngIf="isSwap && maxAmounts"
    class="flex flex-col alert !items-stretch bg-gray-950 text-black"
  >
    <div *ngIf="interpretation" class="mt-2 flex flex-row items-center">
      <ng-container *ngIf="false">
        <!-- activate color classes -->
        <div class="!text-green-300"></div>
        <div class="!text-yellow-300"></div>
        <div class="!text-orange-300"></div>
        <div class="!text-gray-300"></div>
      </ng-container>

      <ng-icon
        name="hero-information-circle-mini"
        size="18"
        [class]="'!text-' + interpretationColor + '-300'"
      ></ng-icon>
      <span class="font-bold">{{
        'rfqInfo.interpretation.' + interpretation | translate
      }}</span>
      <div
        *ngIf="
          interpretation === RfqInterpretation.NOTIFY_MM && canRequestLiquidity
        "
        class="ml-2 flex-1 flex flex-row items-center"
      >
        <a
          (click)="onRequestClick()"
          class="border rounded px-2 py-1 text-sm cursor-pointer hover:bg-gray-700"
          >{{ 'rfqInfo.request.now' | translate }}</a
        >
        <a
          routerLink="liquidity"
          class="ml-2 border rounded px-2 py-1 text-sm cursor-pointer hover:bg-gray-700"
          >{{ 'rfqInfo.request.later' | translate }}</a
        >
        <span
          *ngIf="requestSuccessful"
          class="flex-1 text-right !text-green-300"
          >{{ 'rfqInfo.request.success' | translate }}</span
        >
        <span
          *ngIf="requestSuccessful === false"
          class="flex-1 text-right !text-orange-300"
          >{{ 'rfqInfo.request.error' | translate }}</span
        >
      </div>
    </div>

    <div class="my-2 w-full border-t border-gray-700"></div>

    <div class="flex flex-col">
      <div>
        <span>Currently the max available RFQ amounts are:</span>
      </div>
      <div class="mt-2 flex flex-row">
        <div class="flex-1 flex flex-row items-center">
          <span>{{
            maxAmounts.maxSellAmount
              | assetUnit: sellEntry!.asset.token.decimals!
          }}</span>
          <a
            [href]="
              BLOCK_EXPLORER_TOKEN_LINK(sellEntry!.asset.token.address, chain)
            "
            target="_blank"
            class="ml-2 flex flex-row h-fit px-2 py-1.5 rounded-lg bg-gray-700 hover:bg-gray-600 cursor-pointer"
          >
            <common-token-logo
              [token]="sellEntry!.asset.token"
              [size]="3"
              [mdSize]="4"
              class="self-center min-w-[12px] md:min-w-[16px]"
            ></common-token-logo>
            <span class="ml-1 text-xs">{{
              sellEntry!.asset.token.symbol
            }}</span>
          </a>
        </div>
        <div class="flex-1 text-center items-center">
          <span>{{ maxAmounts.maxValueInUsd | currency }}</span>
        </div>
        <div class="flex-1 flex flex-row justify-end items-center">
          <span>{{
            maxAmounts.maxBuyAmount | assetUnit: buyEntry!.asset.token.decimals!
          }}</span>
          <a
            [href]="
              BLOCK_EXPLORER_TOKEN_LINK(buyEntry!.asset.token.address, chain)
            "
            target="_blank"
            class="ml-2 flex flex-row h-fit px-2 py-1.5 rounded-lg bg-gray-700 hover:bg-gray-600 cursor-pointer"
          >
            <common-token-logo
              [token]="buyEntry!.asset.token"
              [size]="3"
              [mdSize]="4"
              class="self-center min-w-[12px] md:min-w-[16px]"
            ></common-token-logo>
            <span class="ml-1 text-xs">{{ buyEntry!.asset.token.symbol }}</span>
          </a>
        </div>
      </div>
    </div>

    <div class="mt-2 md:mt-4 flex flex-row justify-end">
      <span class="text-3xs text-gray opacity-30">{{
        'rfqInfo.disclaimer' | translate
      }}</span>
    </div>
  </div>
</div>
